import { RegisterForm } from '../../../components/Users/RegisterForm'

export const Register = () => {
    return <RegisterForm />
}
